export function countDown() {
    const countdownField = document.getElementById('countdown');
    if (countdownField) {
        const start_date = new Date(document.getElementById('countdown-startdate').getAttribute('datetime')).getTime();
        let days, hours, minutes, seconds;

        const countdowntimer = setInterval(function () {

            let current_date = new Date().getTime();
            let time_left = (start_date - current_date);

            days = Math.floor(time_left / (1000 * 60 * 60 * 24));
            hours = Math.floor((time_left % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
            minutes = Math.floor((time_left % (1000 * 60 * 60)) / (1000 * 60))
            seconds = Math.floor((time_left % (1000 * 60)) / 1000);

            if (time_left < 0) {
                days = 0;
                hours = 0;
                minutes = 0;
                seconds = 0;
                clearInterval(countdowntimer);
            }

            document.getElementById('countdown-days').innerHTML = String(days).padStart(2, '0');
            document.getElementById('countdown-hours').innerHTML = String(hours).padStart(2, '0');
            document.getElementById('countdown-minutes').innerHTML = String(minutes).padStart(2, '0');
            document.getElementById('countdown-seconds').innerHTML = String(seconds).padStart(2, '0');

        }, 1000)

    }
    return 'countDown';
}
